// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabNavWrapper":"wXeYe","tabList":"_76mTv","tab":"_5pvct","tabActive":"NBHZD","dropdownWrapper":"gqVuN","dropdown":"m5Bvy","dropdownArrow":"_7mhOu"};